document.addEventListener('alpine:init', function () {
    Alpine.data('stickyLink', function () {
        var openTimer = null;
        var closeTimer = null;
        var reopenGuard = false;
        // Matches Tailwind's `md` breakpoint. Below this the dropdown is
        // suppressed and the trigger simply scrolls to its anchor.
        var isDesktop = function () { return window.matchMedia('(min-width: 768px)').matches; };
        return {
            popupOpen: false,
            panelVisible: false,
            openPopup: function () {
                var _this = this;
                if (!isDesktop())
                    return;
                if (reopenGuard)
                    return;
                if (closeTimer) {
                    clearTimeout(closeTimer);
                    closeTimer = null;
                }
                this.popupOpen = true;
                openTimer = setTimeout(function () {
                    if (_this.popupOpen) {
                        _this.panelVisible = true;
                    }
                }, 300);
            },
            closePopup: function () {
                var _this = this;
                if (openTimer) {
                    clearTimeout(openTimer);
                    openTimer = null;
                }
                reopenGuard = true;
                requestAnimationFrame(function () {
                    reopenGuard = false;
                });
                this.panelVisible = false;
                closeTimer = setTimeout(function () {
                    if (!_this.panelVisible) {
                        _this.popupOpen = false;
                    }
                }, 300);
            },
        };
    });
});
